/** Date format string for date-fns (dd/MM/yy). */
export const DATE_FORMAT = "dd/MM/yy";

/** Date-time format string for date-fns (HH:mm:ss dd/MM/yy). */
export const DATE_TIME_FORMAT = "HH:mm:ss dd/MM/yy";

/**
 * Timestamp as the redesign writes it: "Aug 2, 2026 · 18:05".
 *
 * Deliberately not DATE_TIME_FORMAT — that one is the terse `HH:mm:ss dd/MM/yy`
 * used in logs and detail rows, where seconds matter and space does not. This is
 * for list columns a person scans.
 */
export const DATE_STAMP_FORMAT = "MMM d, yyyy · HH:mm";

/**
 * The same stamp without the clock: "Aug 2, 2026".
 *
 * For columns where only the day is the answer — an artifact is added once and
 * the hour it landed tells the reader nothing.
 */
export const DAY_STAMP_FORMAT = "MMM d, yyyy";

/**
 * The same day-first order as {@link DATE_FORMAT}, spelled in PrimeVue's own
 * tokens rather than date-fns': `dd/mm/yy` here means day, month, four-digit year.
 * Without it the DatePicker falls back to its American `mm/dd/yy` default and the
 * one field in the app where a date is typed disagrees with every field that
 * shows one.
 */
export const PRIMEVUE_DATE_FORMAT = "dd/mm/yy";
